import * as React from "react";
import { OldColumn } from "src/components/atoms/OldGrid/OldColumn";
import { OldGrid } from "src/components/atoms/OldGrid/OldGrid";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";

interface Props {
  label?: string;
}
const TEST_ID = "Interstitial";

export const Interstitial = (props: Props) => (
  <OldGrid padded data-testid={TEST_ID}>
    <OldRow padded>
      <OldColumn centerContent></OldColumn>
    </OldRow>
  </OldGrid>
);
Interstitial.TEST_ID = TEST_ID;
